import { render, staticRenderFns } from "./BlanketVOBFeatureDetail.vue?vue&type=template&id=06fdd036&scoped=true"
import script from "./BlanketVOBFeatureDetail.vue?vue&type=script&lang=js"
export * from "./BlanketVOBFeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBFeatureDetail.vue?vue&type=style&index=0&id=06fdd036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fdd036",
  null
  
)

export default component.exports